import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

const fallbackSlides = [
  { id: 1, title: 'Premium Power Loom Parts', subtitle: 'Get up to 50% off Today Only!', description: 'Quality spare parts for your power looms', button_text: 'SHOP NOW', image: '/uploads/herosection/n power-loom-machine.jpg', bg_color: '#f5f5f5' }
];

function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    api.getSlides().then(res => {
      const active = (res.data || []).filter(s => s.is_active == 1);
      setSlides(active.length > 0 ? active : fallbackSlides);
    }).catch(() => setSlides(fallbackSlides));
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  if (slides.length === 0) return null;

  return (
    <div className="hero-slider">
      <div className="slider-container" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
        {slides.map((slide) => (
          <div key={slide.id} className="slide" style={{ backgroundColor: slide.bg_color || '#f5f5f5' }}>
            <div className="slide-content">
              <div className="slide-text">
                <p className="slide-subtitle">{slide.subtitle}</p>
                <h1 className="slide-title">{slide.title}</h1>
                <p className="slide-description">{slide.description}</p>
                <button className="slide-btn">{slide.button_text}</button>
              </div>
              <div className="slide-image">
                <img
                  src={slide.image}
                  alt={`Power Loom Parts - ${slide.title}`}
                  loading="eager"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="600" height="400"%3E%3Crect fill="%23ddd" width="600" height="400"/%3E%3Ctext fill="%23999" x="50%25" y="50%25" text-anchor="middle" dy=".3em" font-family="Arial" font-size="24"%3EPower Loom%3C/text%3E%3C/svg%3E';
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="slider-arrow prev" onClick={() => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)} aria-label="Previous slide">‹</button>
      <button className="slider-arrow next" onClick={() => setCurrentSlide((prev) => (prev + 1) % slides.length)} aria-label="Next slide">›</button>

      <div className="slider-dots">
        {slides.map((_, index) => (
          <button key={index} className={`dot ${index === currentSlide ? 'active' : ''}`} onClick={() => setCurrentSlide(index)} aria-label={`Go to slide ${index + 1}`} />
        ))}
      </div>
    </div>
  );
}

export default HeroSlider;
